import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { Icon } from "@/shared/ui";
import { NotificationProfessionState } from "@/domains/notification/constants/notificationState";
import { Profession } from "@/domains/notification/constants/profession";
import { NotificationStatus } from "@/domains/notification/constants/status";
import { porfessionTranslate } from "@/domains/notification/helpers/professionTranslate";
import NotificationIndicator from "@/domains/notification/components/NotificationIndicator";

type Props = {
  className?: string;
} & NotificationProfessionState;

const icons: Record<Profession, string> = {
  [Profession.BusDriver]: "bus",
};

export default function NotificationProfession({ className, profession, level }: Props) {
  const { t } = useTranslation("notification");

  const percent = Math.trunc((level[0] / level[1]) * 100);

  return (
    <div className={cn("flex flex-col items-center z-1", className)}>
      <motion.div
        initial={{ opacity: 0, translateY: "-100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "-100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          delay: 0.1,
          duration: 0.3,
        }}
        className="flex items-center gap-2.5 mt-5"
      >
        <div className="relative flex items-center justify-center">
          <NotificationIndicator
            fillPercent={percent}
            className="w-[3.75rem] h-[3.75rem]"
            status={NotificationStatus.Inherit}
          />
          <Icon
            category="notification"
            name={icons[profession]}
            className="bg-white w-[1.5rem] absolute"
          />
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, translateY: "100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          duration: 0.3,
          delay: 0.4,
        }}
        className="mt-2.5"
      >
        <div className="text-14 font-bold text-white uppercase whitespace-nowrap text-center">
          {t(porfessionTranslate[profession])}
        </div>
        <div className="text-12 text-white/70 font-bold uppercase whitespace-nowrap text-center">
          {t("notification.levelIncreased")}
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, translateY: "100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          duration: 0.3,
          delay: 0.7,
        }}
        className={clsx(
          "mt-2.5 px-2.5 py-2 whitespace-nowrap rounded-[0.5rem]",
          "bg-gradient-to-r from-white/15 to-white/5",
        )}
      >
        <span className="text-16 text-white font-bold ">{level[0]}</span>{" "}
        <span className="text-13 text-white font-bold uppercase">{t("notification.level")}</span>
      </motion.div>
    </div>
  );
}
